<template>
  <v2-card>
    <template #header>
      <h3 class="v2-heading-sm">
        Segmentation
      </h3>
    </template>

    <div class="v2-profile-seg__grid">
      <!-- Departments -->
      <div class="v2-profile-seg__field v2-profile-seg__field--full">
        <v2-select
          v-model="segmentationLocal.departments"
          label="Departments"
          :options="departments || []"
          placeholder="Select departments"
          :multiple="true"
          :disabled="isNotEntityAdmin"
        />
      </div>

      <!-- Avg Retail Price -->
      <div class="v2-profile-seg__field">
        <v2-select
          v-model="segmentationLocal.avgRetailPrice"
          label="Average Retail Price"
          :options="retailPriceOptions"
          placeholder="Select average retail price"
          :disabled="isNotEntityAdmin"
        />
      </div>

      <!-- Avg Wholesale Price -->
      <div class="v2-profile-seg__field">
        <v2-select
          v-model="segmentationLocal.avgWholesalePrice"
          label="Average Wholesale Price"
          :options="wholesalePriceOptions"
          placeholder="Select average wholesale price"
          :disabled="isNotEntityAdmin"
        />
      </div>
    </div>

    <!-- Actions -->
    <div class="v2-profile-seg__actions">
      <v2-button
        variant="primary"
        :loading="loading"
        :disabled="loading || isNotEntityAdmin"
        @click="onSave"
      >
        Save changes
      </v2-button>
      <v2-button
        variant="outline"
        :disabled="isNotEntityAdmin"
        @click="onReset"
      >
        Reset
      </v2-button>
    </div>
  </v2-card>
</template>

<script>
import { computed, watch } from '@vue/composition-api'
import { useSegmentation } from '@/composables/useSegmentation'
import V2Card from '@/components/v2/V2Card.vue'
import V2Button from '@/components/v2/V2Button.vue'
import V2Select from '@/components/v2/V2Select.vue'

export default {
  name: 'V2ProfileSegmentation',
  components: {
    V2Card,
    V2Button,
    V2Select,
  },
  props: {
    segmentationData: {
      type: Object,
      default: null,
    },
    departments: {
      type: Array,
      default: () => [],
    },
    countries: {
      type: Array,
      default: () => [],
    },
    kingpinPresenceCountries: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update-segmentation'],
  setup(props, { emit }) {
    const seg = useSegmentation()
    seg.initSegmentation(props.segmentationData, props.countries, props.kingpinPresenceCountries)

    const retailPriceOptions = computed(() => seg.retailPrices || [])
    const wholesalePriceOptions = computed(() => seg.wholesalePrices || [])

    function onSave() {
      seg.saveSegmentation(savedData => {
        emit('update-segmentation', savedData)
      })
    }

    function onReset() {
      seg.resetForm(props.segmentationData)
    }

    watch(
      () => props.segmentationData,
      newData => {
        if (newData) {
          seg.resetForm(newData)
        }
      },
    )

    return {
      ...seg,
      retailPriceOptions,
      wholesalePriceOptions,
      onSave,
      onReset,
    }
  },
}
</script>

<style lang="scss" scoped>
.v2-profile-seg {
  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--v2-space-4);
    margin-top: var(--v2-space-4);
    margin-bottom: var(--v2-space-5);
  }

  &__field {
    display: flex;
    flex-direction: column;

    &--full {
      grid-column: 1 / -1;
    }
  }

  &__actions {
    display: flex;
    gap: var(--v2-space-3);
  }

  @media (max-width: 640px) {
    &__grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>
